import React, { useEffect, useState } from "react";
import DataComponent from "../../DataComponent";
import Icon from "../../Icon";
import LockIcon from "../../../assets/images/icon/lock.svg";
import ShieldIcon from "../../../assets/images/icon/shield.svg";
import { CardUnit, ColCard, Row } from "../../ContentLayout";
import { CardBody, CardHeader, CardTitle } from "reactstrap";
import { isEmpty } from "lodash";
import {
  getFinancesType,
} from "../../../apis/finances/auth";
import { viewLoading } from "../../../utils/loading";
import Badge from "../../Badge";
import { modifyTaxAccountantFinancesAccounts, postTaxAccountantFinancesAuth } from "../../../apis/tax-accountant-finance/auth";
import FinancesCert from "../../FinancesCert/idnex";

export const findCertName = (cert) => {
  const certVal = String(cert);
  const cutIdx = certVal.lastIndexOf("(");

  return certVal.substring(0, cutIdx);
};

const TaxAccountantWetaxCert = (props) => {
  const { setHeaderButtons, getAccount, accountInfo, state } = props;

  const [isFinancesCertShow, setIsFinancesCertShow] = useState(false);
  useEffect(() => {
    setHeaderButtons([])
  }, [setHeaderButtons])

  const submit = (data) => {
    viewLoading(true);
    if (isEmpty(accountInfo)) {
      // 첫 등록
      const formData = {
        orgCd: "tax-accountant-wetax",
        loginMethod: "CERT",
        signCert: data.DER2PEM,
        signPri: data.KEY2PEM,
        signPw: data.password,
        signName: data.certName,
        signProvider: data.pub,
        signExpired: data.toDt,
        // userId: data.userId,
        // userPw: data.userPw,
        // agentId: data.agentId,
        // agentPw: data.agentPw,
      };

      postTaxAccountantFinancesAuth(formData)
        .then(() => {
          getAccount();
        })
        // .catch((err) => {
        //   console.log(err.response.message);
        // })
        .finally(() => viewLoading(false));
    } else {
      // 인증서 변경
      const formData = {
        loginMethod: "CERT",
        signCert: data.DER2PEM,
        signPri: data.KEY2PEM,
        signPw: data.password,
        signName: data.certName,
        signProvider: data.pub,
        signExpired: data.toDt,
        userId: data.userId,
        userPw: data.userPw,
        agentId: data.agentId,
        agentPw: data.agentPw,
      };
      modifyTaxAccountantFinancesAccounts(accountInfo.idx, formData).then(() => {
        getAccount();
      }).catch(() => { })
        .finally(() => viewLoading(false));
    }
  };


  return (
    <>
      <Row>
        <ColCard>

          <div className="home-tax-wrap">
            <CardHeader className="border-bottom-none">
              <CardTitle>
                <span className="card-header-title">인증서 정보</span>
              </CardTitle>
              <CardUnit>
                <DataComponent
                  field={{
                    type: "button",
                    label: isEmpty(accountInfo) ? "인증 정보 등록" : "인증 정보 변경",
                    size: "small",
                    color: "line",
                    action: () => {
                      getFinancesType("hometax").then((res) => {
                        setIsFinancesCertShow(true);
                      });
                    },
                  }}
                />
              </CardUnit>
            </CardHeader>
            <CardBody className="p-0 margin-top-14">
              <div className="cert-on-box">
                {!isEmpty(accountInfo) ? (
                  <>
                    <div className="left-site">
                      <div className="lock-shield-icon-wrap">
                        <Icon src={LockIcon} className="lock-icon" />
                        <div className="shield-icon-wrap">
                          <Icon src={ShieldIcon} className="shield-icon" />
                        </div>
                      </div>
                    </div>
                    <div className="right-site">
                      <p className="company-name">
                        {findCertName(accountInfo.signName) || accountInfo.signName}
                        {!isEmpty(state) && (
                          <Badge
                            className="margin-left-8"
                            color={state.color}
                            size="sm"
                            label={state.label}
                          />
                        )}
                      </p>
                      <p className="expire-date">
                        만료일<span className="date">{accountInfo.signExpired}</span>
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="empty-cert">등록된 인증서가 없습니다.</div>
                  </>
                )}
              </div>
            </CardBody>

            <FinancesCert
              isShow={isFinancesCertShow}
              toggle={setIsFinancesCertShow}
              submit={submit}
            />
          </div>
        </ColCard>
      </Row>


    </>
  );
};

export default TaxAccountantWetaxCert;